import React from "react";
import { TabbedCodeExample } from "../../../../../src/markdown-components";

const importRouteHandler = `import { RouteHandler } from "gadget-server";\n`;

export const getRouteFunctionSignatureWithShopIdAndChargeId = (isTs: boolean) =>
  isTs
    ? "const route: RouteHandler<{ Querystring: { shop_id: string; charge_id: string; }; }> = async ({ request, reply, api, connections }) => {"
    : "/** @type { RouteHandler<{ Querystring: { shop_id: string, charge_id: string; }; }> }*/\nconst route = async ({ request, reply, api, logger, connections }) => {";

const getFinishPaymentRouteCodeSnipRouteBody = (includeNameInGqlQuery?: boolean) => `
  // get an instance of the shopify-api-node API client for this shop
  const shopify = await connections.shopify.forShopId(request.query.shop_id);

  // make an API call to Shopify to validate that the charge object for this shop is active
  const result = await shopify.graphql(\`
    query {
      node(id: "gid://shopify/AppSubscription/\${request.query.charge_id}") {
        id
        ... on AppSubscription {
          status${includeNameInGqlQuery ? "\n          name" : ""}
        }
      }
    }
  \`);

  if (result.node.status != "ACTIVE") {
    // the merchant has not accepted the charge, so we can show them a message
    await reply.code(400).send("Invalid charge ID specified");
    return;
  }
  // the merchant has accepted the charge, so we can grant them access to our application
  // example: mark the shop as paid by setting a \`plan\` attribute, this may vary for your billing model
  await api.internal.shopifyShop.update(request.query.shop_id, { plan: "basic" });

  // send the user back to the embedded app
  await reply.redirect("/");

}

export default route; `;

export const FinishPaymentRouteCodeSnip = (props: { includeNameInGqlQuery?: boolean }) => {
  return (
    <TabbedCodeExample
      disableTranspiler
      useRawCode
      filename="api/routes/GET-finish-payment.ts"
      examples={{
        typescript:
          importRouteHandler +
          getRouteFunctionSignatureWithShopIdAndChargeId(true) +
          getFinishPaymentRouteCodeSnipRouteBody(props.includeNameInGqlQuery),
        javascript:
          importRouteHandler +
          getRouteFunctionSignatureWithShopIdAndChargeId(false) +
          getFinishPaymentRouteCodeSnipRouteBody(props.includeNameInGqlQuery),
      }}
    />
  );
};
